export const paths = {
    index: '/',
    login: '/auth/login',
    publicUpInfo: '/public/productiveUnit/:productiveUnitUid/info',
    home: '/home',
    changePassword: '/changePassword',
    harvests: '/harvest/list/',
    productiveUnits: '/productiveUnit/list',
    productiveUnit: '/productiveUnit/:productiveUnitUid',
    newProductiveUnit: '/productiveUnit/new',
    productiveUnitInfo: '/productiveUnit/:productiveUnitUid/info',
    events: '/event/list',
    event: '/event/:eventUid',
    eventPrescription: '/event/:eventUid/prescription',
    newEvent: '/event/new',
    technicalMonitoring: '/technicalMonitoring/:eventTechmonUid',
    newTechnicalMonitoring: '/technicalMonitoring/new',
    reports: '/report/list',
    report: '/report/:reportUid',
    mapViewer: '/mapViewer',
    baselineEnvironments: '/baselineEnvironment/list',
    newBaselineEnvironment: '/baselineEnvironment/new',
    baselineEnvironment: '/baselineEnvironment/:baselineEnvironmentUid',
    baselineEnvironmentCompleted: '/baselineEnvironment/:baselineEnvironmentUid/completed'
} as const

export type Path = typeof paths[keyof typeof paths]
